import { UserIcon } from '@heroicons/react/24/solid'
import { ReactElement, useEffect, useMemo, useState } from 'react'
import ComboMultiSelect from 'app/components/ui/combo/combo-multi-select'
import { bg } from 'lib/background'
import { logError } from 'lib/logging'
import { OptionType } from 'types/OptionType'
import { gqlFetchList } from 'app/lib/graphqlClient'

/**
 * Component that searches for staff that have answered calls and returns a staff dropdown.
 * @returns Component with staff members to be used as a filter
 */
export function StaffSelector({
  inputClassName,
  selectedStaff,
  onStaffChange,
}: {
  inputClassName?: string
  selectedStaff: string[]
  onStaffChange: (staff: string[]) => void
}): ReactElement {
  const allStaffOption = { name: `All Staff`, id: `0`, value: `` }
  const [staffOptions, setStaffOptions] = useState<OptionType[]>([])

  useEffect(() => {
    bg(async () => {
      gqlFetchList<{ id: string; name: string }>('users', { search: 'type:staff' }, 'id name')
        .then((result) => {
          if (result.hits) {
            setStaffOptions(result.hits.map((s) => ({ id: s.id, value: s.id, name: s.name })))
          }
        })
        .catch((error) => {
          logError(error)
        })
    })
  }, [selectedStaff])

  const selectedOptions = useMemo(() => {
    const selectedStaffOptions = staffOptions.filter((option) => selectedStaff.includes(option.value))
    return selectedStaffOptions
  }, [staffOptions, selectedStaff])

  return (
    <ComboMultiSelect
      className="w-52 cursor-pointer"
      optionsContainerClassName="w-64 right-0"
      placeholder="filter by staff"
      values={selectedOptions}
      options={staffOptions}
      name="staff-selector"
      onChange={(options) => onStaffChange(options.map((option) => option.value))}
      icon={<UserIcon className="h-4 w-4 fill-current text-default" />}
      enableDeselectAllOption={true}
      deselectAllOptions={[allStaffOption]}
      inputClassName={inputClassName}
    />
  )
}
